module.exports = __webpack_public_path__ + "img/pk.cf3140cd.svg";